import {
  QueryMode,
  SortDirection,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { useEventListQuery } from "@ticketingplatform/api/dist/event";
import { useDebouncedValue } from "hooks/useDebouncedValue";
import { useAutoComplete } from "hooks/useAutoComplete";
import { useVenueContext } from "contexts/VenueContext";

import { UseEventSelect } from "./types";

export const useEventSelect: UseEventSelect = (props) => {
  const { venue } = useVenueContext();
  const [searchValue, debouncedSearch, onSearch] = useDebouncedValue<
    string | undefined
  >(undefined, 1000);

  const { data, loading } = useEventListQuery({
    variables: {
      venueInclude: false,
      imageInclude: false,
      seatMapInclude: false,
      ticketPoolsInclude: false,
      discountCodesInclude: false,
      orderBy: [{ name: SortDirection.asc }],
      take: 10,
      filters: {
        ...(venue ? { venueId: { equals: venue.id } } : {}),
        ...(debouncedSearch
          ? {
              name: {
                contains: debouncedSearch,
                mode: QueryMode.insensitive,
              },
            }
          : {}),
      },
    },
  });

  return useAutoComplete({
    ...props,
    loading,
    searchValue,
    onSearch,
    options: data?.events?.nodes || [],
    valueProp: "id",
    labelProp: "name",
  });
};
